import { useLocation } from 'react-router-dom'
import useFetch from '../utils/useFetch'
import EduTourism from '../components/trainingAndServices/eduTourism'
import Elevate from '../components/trainingAndServices/elevate'
import Iep from '../components/trainingAndServices/iep'
import Apel from '../components/trainingAndServices/apel'
import ShortCourses from '../components/trainingAndServices/shortCourses'

const TrainingServicesPages = () => {
  const location = useLocation()
  const { pathname } = location
  const params = pathname
    .split('/')
    ?.filter(param => param !== '' && param !== 'training-services')
  const pageName = params[params.length - 1]

  // Set pathname to null for 'apel' to prevent API call
  const fetchPath = pageName === 'apel' ? null : pathname
  const apelAPath = pageName === 'apel' ? '/training-services/apel-a/' : null
  const apelCPath = pageName === 'apel' ? '/training-services/apel-c/' : null

  // Always call hooks unconditionally
  const data = useFetch(fetchPath)
  const apelAData = useFetch(apelAPath)
  const apelCData = useFetch(apelCPath)

  // Handle loading state
  if (pageName === 'apel' && (!apelAData || !apelCData)) {
    return (
      <div className='flex items-center justify-center min-h-screen min-w-screen'>
        <div className='w-16 h-16 border-4 border-dashed rounded-full animate-spin border-gray-950'></div>
      </div>
    )
  }
  if (pageName !== 'apel' && !data) {
    return (
      <div className='flex items-center justify-center min-h-screen min-w-screen'>
        <div className='w-16 h-16 border-4 border-dashed rounded-full animate-spin border-gray-950'></div>
      </div>
    )
  }

  // Handle error state
  if (
    pageName === 'apel' &&
    (apelAData?.status === '404' || apelCData?.status === '404')
  ) {
    return <div>Error</div>
  }
  if (pageName !== 'apel' && data?.status === '404') {
    return <div>Error</div>
  }

  switch (pageName) {
    case 'edu-tourism':
      return <EduTourism data={data?.properties} />
    case 'elevate':
      return <Elevate data={data?.properties} />
    case 'iep':
      return <Iep data={data?.properties} />
    case 'apel':
      return (
        <Apel
          apelAData={apelAData?.properties}
          apelCData={apelCData?.properties}
        />
      )
    case 'short-course':
      return <ShortCourses data={data?.properties} />
    default:
      return (
        <div>
          TrainingServicesPages: {pageName}: {JSON.stringify(data?.status)}
        </div>
      )
  }
}

export default TrainingServicesPages
